<template>
  <div class="contact-page-contact-list">
    <!-- COMPANY -->
    <div v-if="company">
      <CollapsableCategory
        value="Company"
        :init_expanded="true"
        :color="foreground_color"
      >
        <template #content="{ is_collapsed, }">
          <TransitionAccordion>
            <div v-if="!is_collapsed" class="contact-page-list-company">
              <!-- TODO: user should be able to place image vertically -->
              <v-img
                eager
                :src="company.image"
                height="64px"
              />
              <div>
                <TText
                  :text="company.name"
                  :color="foreground_color"
                  :size="14"
                  :font_weight="400"
                />
                <TText
                  :text="`${company.address.street} ${company.address.house_nr} ${company.address.additional_info}`"
                  medium
                  :color="foreground_color"
                />
                <TText
                  :text="`${company.address.zip_code} ${company.address.city}`"
                  medium
                  :color="foreground_color"
                />
              </div>
                <!-- TODO: color link in appropriate color -->
                <span>
                  <a :href="`mailto:${company.mail}`">
                    <TText
                      :text="company.mail"
                      small
                      :color="foreground_color"
                    />
                  </a>
                </span>
                <!-- TODO: color link in appropriate color -->
                <span>
                  <a :href="`tel:${company.phone_nr}`">
                    <TText
                      :text="company.phone_nr"
                      small
                      :color="foreground_color"
                    />
                  </a>
                </span>
            </div>
          </TransitionAccordion>
        </template>
      </CollapsableCategory>
    </div>

    <!-- ROLES -->
    <div v-if="roles">
      <CollapsableCategory
        v-for="(role, index) in roles"
        :key="`${role.name}${index}`"
        :description="role.name"
        :init_expanded="true"
        :color="foreground_color"
      >
        <template #content="{ is_collapsed, }">
          <TransitionAccordion>
            <div v-if="!is_collapsed">
              <ClickableListItem
                v-for="(person, index) in role.persons"
                :key="`${person.name}${index}`"
                :id="person.id"
                :is_selected="person.id === selected_id"
                :has_lines="has_lines"
                :is_first="index===0"
                :margin="6"
                :background_color="background_color"
                :foreground_color="foreground_color"
                @emittedClick="handleClick(person)"
              >
                <template #front>
                  <div
                    class="contact-page-list-image"
                    :style="`
                      background-image:url(${person.image});
                      box-shadow: 0px 2px 2px ${getTranspHexColor(foreground_color, .33)};`"
                  />
                </template>

                <template #descriptor>
                  <TText
                    :text="person.name"
                    medium
                    :color="foreground_color"
                    align="left"
                  />
                </template>

                <template #info>
                  <div class="contact-page-list-icons">
                    <v-btn
                      icon
                      small
                      :ripple="person.has_email"
                      :color="person.has_email
                        ? foreground_color
                        : getTranspHexColor(foreground_color, .33)"
                      @click.prevent.stop="person.has_email
                        ? handleClickEvent(`${person.name}'s email`)
                        : handleClickEvent(person.name)"
                    >
                      <TIcon name="email"/>
                    </v-btn>
                    <v-btn
                      icon
                      small
                      :ripple="person.has_phone"
                      :color="person.has_phone
                        ? foreground_color
                        : getTranspHexColor(foreground_color, .33)"
                      @click.prevent.stop="person.has_phone
                      ? handleClickEvent(`${person.name}'s phone number`)
                      : handleClickEvent(person.name)"
                    >
                      <TIcon name="phone"/>
                    </v-btn>
                  </div>
                </template>
              </ClickableListItem>
            </div>
          </TransitionAccordion>
        </template>
      </CollapsableCategory>
    </div>
  </div>
</template>

<script>
import CollapsableCategory from '@/components/WorkPackageWIP/CollapsableCategory.component.vue';
import TransitionAccordion from '@/components/WorkPackageWIP/TransitionAccordion.component.vue';
import ClickableListItem  from '@/components/WorkPackageWIP/ClickableListItem.component.vue';
import TText  from '@/components/Taktify/TText.component.vue';
import TIcon  from '@/components/Taktify/TIcon.component.vue';
import { TColor } from '@/mixins/TColor.mixin.js';

  export default {
    components: {
      CollapsableCategory,
      TransitionAccordion,
      ClickableListItem,
      TText,
      TIcon,
    },

    mixins: [
      TColor,
    ],

    props: [
      'roles', // is array of objects
      'company', // is object
      'has_lines', // is boolean, toggles lines between list items
      'background_color', // is string, contains hexadecimal value of background
      'foreground_color', // is string, contains hexadecimal value of text, outlines etc.
    ],

    data: () => ({
      selected_id: -1,
    }),

    methods: {
      handleClick(person) {
        this.selected_id = person.id;
      },

      resetSelectedId() {
        this.selected_id = -1;
      },

      log(string, is_selected) {
        console.log(`${string} got ${is_selected ? 'selected' : 'deselected'}!`);
      },
    },
  }
</script>

<style>
  .contact-page-contact-list {
    width: 100%;
  }
  .contact-page-list-company {
    display: flex;
    flex-direction: column;
    grid-gap: 8px;
  }
  .contact-page-list-company > span {
    line-height: 1;
  }
  .contact-page-list-company > span > a {
    display: inline-block;
  }
  .contact-page-list-image {
    height: 32px;
    width: 32px;
    border-radius: 18px;
    background-size: cover;
    background-position: center;
  }
  .contact-page-list-icons {
    display: flex;
    grid-gap: 8px;
  }
  .contact-page-list-icons > .v-btn::before {
    background-color: transparent;
  }
</style>
